// FIN-12017 — Build the Typology/Variant drawer record from the alert's
// `triggeredRules` and the scenario's typologies list, fully null-safe.
//
// The Explanation-tab variant ⓘ used to hang with an infinite spinner: when the
// triggered rule's `typologyId` was not present in the scenario's typologies
// (cloned scenario / variant-id drift) or when `typology.rules` was null,
// `JSON.parse(typologyInfo.rules)` threw inside the onOpenDrawer `.then()`, so
// `showDrawer` was never called and the drawer never stopped loading. This
// builder never throws and always returns a usable record, so the drawer opens
// with whatever data is available.
const safeParseArray = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export function buildVariantDrawerRecord(
  triggeredRules,
  typologies,
  triggerName
) {
  const typologyList = Array.isArray(typologies) ? typologies : [];

  const variantInfo = safeParseArray(triggeredRules).find(
    (f) => f.ruleName === triggerName
  ) || {
    rule: {}
  };

  const typologyInfo =
    typologyList.find((typology) => typology.id === variantInfo.typologyId) ||
    {};

  const typologyInfoRules =
    safeParseArray(typologyInfo.rules).find(
      (f) => f.ruleName === triggerName
    ) || {};

  return {
    ...typologyInfo,
    ...typologyInfoRules,
    variantName: triggerName,
    typologyId: variantInfo.typologyId,
    typologiesReadOnly: typologyList
  };
}
